var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-row gap-4 items-top customContainer pt-2 pb-2 justify-flex-start items-flex-start flex-wrap",
    },
    [
      [
        _c(
          "div",
          { staticClass: "flex flex-col items-top gap-4 sm:flex-row" },
          [
            _c("FormGroup", {
              key: "item1",
              attrs: {
                title: "",
                type: "search",
                iconStyle: "customIcon",
                inputClass: "customFormInput fullwidthAssignee",
                placeholder: "Search by Client name",
                debounceTime: 500,
              },
              model: {
                value: _vm.client_name,
                callback: function ($$v) {
                  _vm.client_name = $$v
                },
                expression: "client_name",
              },
            }),
            _c(
              "FormGroup",
              { key: "item8", staticClass: "mb-2 w-24 mr-3" },
              [
                _c("FormDatepicker", {
                  attrs: {
                    iconStyle: "customIcon",
                    inputClass: "customFormInput",
                    calendarClass:
                      "right-0 sm:right-0 sm:left-auto left-0 sm:left-auto",
                    customInputClass: "rounded-lg text-storm-gray text-sm h-1",
                    name: _vm.isDateOffered ? "Date offered" : "Visit date",
                    label: "",
                    placeholder: _vm.isDateOffered
                      ? "Date offered"
                      : "Visit date",
                  },
                  on: { input: _vm.handleUpdate },
                  model: {
                    value: _vm.contractorUpdatedAt,
                    callback: function ($$v) {
                      _vm.contractorUpdatedAt = $$v
                    },
                    expression: "contractorUpdatedAt",
                  },
                }),
              ],
              1
            ),
            !_vm.hideContractorsFilter
              ? _c(
                  "FormGroup",
                  { key: "item2" },
                  [
                    _c("ContractorsMultiselect", {
                      key: "item2",
                      attrs: {
                        value: _vm.filters.contractors,
                        getParentcontainerStyle: "customWidthMax smallHeight",
                        placeholder: "Resource",
                        multiple: "",
                        contractorsConditions:
                          _vm.contractorsMultiselectConditions,
                        debounceTime: 1000,
                      },
                      on: {
                        input: (chosenContractors) =>
                          (_vm.contractorsIds = chosenContractors),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c("FormGroup", {
              key: "item2",
              attrs: {
                title: "",
                type: "search",
                iconStyle: "customIcon",
                inputClass: "customFormInput",
                placeholder: "Search by address",
                debounceTime: 500,
              },
              model: {
                value: _vm.location,
                callback: function ($$v) {
                  _vm.location = $$v
                },
                expression: "location",
              },
            }),
            !_vm.hideManagersFilter
              ? _c(
                  "FormGroup",
                  { key: "item6" },
                  [
                    _c("ManagersMultiselect", {
                      attrs: {
                        value: _vm.filters.managers,
                        getParentcontainerStyle: "customWidthMax smallHeight",
                        multiple: "",
                        additionalConditions: _vm.managersMultiselectConditions,
                        debounceTime: 1000,
                      },
                      on: {
                        input: (chosenManagers) =>
                          (_vm.managersIds = chosenManagers),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            !_vm.hideBudgetFilter
              ? _c(
                  "FormGroup",
                  { key: "item7" },
                  [
                    _c("InputRangeFilter", {
                      attrs: {
                        minValue: _vm.minBudget,
                        maxValue: _vm.maxBudget,
                        inputClasses: "pl-8 w-24",
                        iconStyle: "customIcon",
                        inputClass: "customFormInput",
                        prefix: "$",
                      },
                      on: {
                        "update:minValue": function ($event) {
                          _vm.minBudget = $event
                        },
                        "update:min-value": function ($event) {
                          _vm.minBudget = $event
                        },
                        "update:maxValue": function ($event) {
                          _vm.maxBudget = $event
                        },
                        "update:max-value": function ($event) {
                          _vm.maxBudget = $event
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          [
            _c("UiButtonMessage", {
              attrs: {
                buttonClass: "customAdd",
                buttonText: "Reset",
                textClass: "customText customOnlyText",
              },
              on: { click: _vm.handleReset },
            }),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }